import React from "react";
import { withTranslation } from "react-i18next";

import UIDs from "../../UIDs";

const uid = UIDs.screens.portal.undone;

class UndoneScreen extends React.Component {
    render() {
        return (
            <div style={{minHeight: "500px", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "100px"}}>
                <div>
                    <h3>{this.props.t("pageIsUnderConstruction")}</h3>
                </div>
            </div>
        );
    }
}

export default withTranslation(uid)(UndoneScreen);